<template>
    <div>
        <p class="text-h5">Mid-decade district plans</p>

        <p class="text-h6">
            <strong>Click a state below to view new, mid-decade congressional maps.</strong>
        </p>

        <ul>
            <li v-for="st in states" :key="st.fips" role="button" tabindex="0" @click="selectState(st)">
                <a>{{ st.name }}</a>
            </li>
        </ul>

        <!-- <p class="text-body-1">The maps underneath this note reflect congressional &amp; state legislative districts
            <strong>before</strong> the 2021-2022 redistricting cycle.</p> -->
    </div>
</template>

<script>
import { EventBus } from "../../js/DataManagement/EventBus";

export default {
    name: "ModalUpdate",
    computed: {
        states() {
            return [
                { fips: "22", name: "Louisiana (adopted May 2026)" },
                { fips: "47", name: "Tennessee (adopted May 2026)" },
                { fips: "12", name: "Florida (adopted May 2026)" },
                { fips: "49", name: "Utah (adopted Dec. 2025)" },
                { fips: "06", name: "California (adopted Nov. 2025)" },
                { fips: "39", name: "Ohio (adopted Nov. 2025)" },
                { fips: "29", name: "Missouri (adopted Oct. 2025)" },
                { fips: "37", name: "North Carolina (adopted Oct. 2025)" },
                { fips: "48", name: "Texas (adopted Sept. 2025)" },
                // { fips: "45", name: "South Carolina" },
            ];
        },
    },
    methods: {
        selectState(selectedState) {
            this.$store.commit("setSelectedState", selectedState.fips);
            EventBus.$emit("zoomToState");
            EventBus.$emit("close-modal");
        },
    },
};
</script>

<style scoped>
li[role="button"] {
    cursor: pointer;
}
</style>
